<template lang="pug">
.content(:class="isTimeslotLowerThan15Min ? `content-slim` : ``")
  .top-row-holder.flex.justify-between.flex-none
    .top-left-data
      BriqTooltip(:help="bookingNumberTooltip" :position="bookingCardPosition <= 90 ? `bottom-left`:`top-left`")  
        .booking-customer(data-test-id="booking-customer" :title="bookingProduct.CustomerName") {{ bookingProduct.CustomerName }}
      .time(data-test-id="booking-card-time") {{ bookingProductTime }}
    .top-right-icons.flex.flex-none
      .booking-card-icon
        BriqTooltip(help="Number of participants" :position="bookingCardPosition <= 90 ? `bottom-left`:`top-left`")
          span.no-of-participants {{ bookingProduct.Quantity }}/{{ bookingProduct.NumberOfPersonsInBooking }}
      .booking-card-icon
        BriqTooltip(:help="checkedInStatusTooltip" :position="bookingCardPosition <= 90 ? `bottom-left`:`top-left`")
          BriqIcon(:name="`icon-participant-${checkedInStatusColor}-planboard`")
      .booking-card-icon
        BriqTooltip(:help="paidTooltip" :position="bookingCardPosition <= 90 ? `bottom-left`:`top-left`")
          BriqIcon(:name="`icon-creditcard-${paidStatusColor}-planboard`" customStyle="margin-top: 5px;")
  .bottom-right-icons.flex.flex-none.justify-end(v-if="isTimeslotgreaterThan25Min" data-test-id="bottom-icons")
    .segment-card-icon(v-if="bookingProduct.SegmentAvatar")
      BriqTooltip(:help="bookingProduct.SegmentAvatar.Name" position="top-left")
        .segment(
          v-if="bookingProduct.SegmentAvatar"
          :style="`background-color: ${bookingProduct.SegmentAvatar.Color}`"
          ) {{ bookingProduct.SegmentAvatar.ShortName }}
    .booking-card-icon(v-if="bookingProduct.MultiActivity" data-test-id="multiactivity-icon")
      BriqTooltip(:help="multiActivityTooltip" position="top-left")
        BriqIcon(name="icon-multiactivity-planboard")
    .booking-card-icon(v-if="bookingProduct.BookingHasNotes" data-test-id="notes-icon")
      BriqTooltip(:help="bookingHasNotesTooltip" position="top-left")
        BriqIcon(name="icon-comment-planboard")
</template>
<script>
import { currencyFormatter } from '@/helpers/intlFormatter.js'

export default {
  name: 'BookingProductCardContent',
  props: {
    bookingProduct: Object,
    bookingProductTime: String,
    bookingCardPosition: Number,
    bookingCardHeight: Number,
  },
  computed: {
    bookingNumberTooltip() {
      return `Booking number: ${this.bookingProduct.BookingNumber}`
    },
    checkedInStatusTooltip() {
      const notLabel = !this.bookingProduct.BookingCheckedIn ? ' not ' : ''
      return `Visitor(s) has ${notLabel} checked in`
    },
    checkedInStatusColor() {
      return this.bookingProduct.BookingCheckedIn ? 'green' : 'gray'
    },
    paidStatusColor() {
      return this.bookingProduct.BookingFullyPaid ? 'green' : 'gray'
    },
    bookingHasNotesTooltip() {
      return this.bookingProduct.BookingHasNotes ? 'Note present' : ''
    },
    paidTooltip() {
      const formatPrice = currencyFormatter(this.$locale, this.$currency).format
      const amountPaid = formatPrice(this.bookingProduct.BookingAmountPaid)

      if (this.bookingProduct.BookingFullyPaid) return `Booking is fully paid (${amountPaid})`
      if (this.bookingProduct.BookingAmountPaid > 0)
        return `Amount paid for this booking is ${amountPaid}`
      return 'Booking is not paid'
    },
    multiActivityTooltip() {
      return 'Multiple activities'
    },
    isTimeslotLowerThan15Min() {
      return this.bookingCardHeight < 58.5
    },
    isTimeslotgreaterThan25Min() {
      return this.bookingCardHeight > 80
    },
  },
}
</script>

<style scoped lang="stylus">
.content
  margin-top 8px
  margin-left 16px
  width 85%

  .top-row-holder
    width 177px

    .booking-customer
      font-weight 500
      font-size 12px
      line-height 16px
      color #000E28 //black1
      text-overflow ellipsis
      overflow hidden
      width 98px
      white-space nowrap

  .bottom-right-icons
    position absolute
    bottom 6px
    right 17px
    display flex
    align-items center
    height 24px

    .segment
      background-color #000E28 //black1
      border-radius 3px
      color white
      font-size 11px
      height 13px
      width 16px
      text-align center
      line-height 13px
      margin-left 5px
      margin-top -2px
      cursor default

  .time
    font-size 10px
    color #4E5A6A //grey800

  .booking-card-icon
    margin-left 5px
    position relative
    top -1px
    cursor default

    .no-of-participants
      color #798696
      font-size 12px

  .cc-card-icon
    margin-top 5px

.content-slim
  margin-top 1px
</style>
